export default __webpack_public_path__ + "static/carvingtools-04f5df256b6198a259346b8da556e461.png";